import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-weight-bold form-label-required mb-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Selection = _resolveComponent("Selection");
    const _component_Field = _resolveComponent("Field");
    const _component_ErrorMessage = _resolveComponent("ErrorMessage");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tr('viiu.componentMuting.AFFECTED_COMPONENT')), 1),
        _createVNode(_component_Field, {
            "model-value": _ctx.modelValue,
            rules: _ctx.Validator.REQUIRED,
            name: _ctx.tr('viiu.componentMuting.AFFECTED_COMPONENT'),
            "validate-on-input": ""
        }, {
            default: _withCtx(({ meta }) => [
                _createVNode(_component_Selection, {
                    "model-value": _ctx.modelValue,
                    state: _ctx.getStateForComponentValidation(meta),
                    "allow-empty": false,
                    "close-on-select": true,
                    disabled: false,
                    options: _ctx.componentFilterOptions,
                    placeholder: _ctx.tr('viiu.componentMuting.COMPONENT_SELECTION_PLACEHOLDER'),
                    loading: _ctx.isLoading,
                    "preserve-search": true,
                    searchable: true,
                    "show-checkboxes": false,
                    multiple: false,
                    "max-height": 250,
                    "group-values": "groupOptions",
                    "group-label": "groupName",
                    label: "label",
                    "track-by": "value",
                    onSelect: _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:model-value', value))
                }, null, 8, ["model-value", "state", "options", "placeholder", "loading"])
            ]),
            _: 1
        }, 8, ["model-value", "rules", "name"]),
        _createVNode(_component_ErrorMessage, {
            name: _ctx.tr('viiu.componentMuting.AFFECTED_COMPONENT'),
            as: "div",
            class: "text-danger mt-1"
        }, null, 8, ["name"])
    ]));
}
